import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { PriceScalePipe } from '../pipes/price-scale.pipe';
import { PercentageChangePipe } from '../pipes/percentage-change-pipe';
import { V3TabNavigation } from '../v3-tab-navigation/v3-tab-navigation';
import { ThemeService } from '../services/theme';
import { themeAsset } from '../services/theme-asset';

@Component({
  selector: 'app-v3-zero-desktop-header',
  templateUrl: './v3-zero-desktop-header.html',
  styleUrl: './v3-zero-desktop-header.scss',
  standalone: true,
  imports: [PriceScalePipe, PercentageChangePipe, V3TabNavigation],
})
export class V3ZeroDesktopHeader {
  @Input() stockName = '';
  @Input() stockLogo!: string | null;
  @Input() price!: number | null;
  @Input() prevPrice!: number | null;
  @Input() activeTab = 'main';
  @Input() tabs: { label: string; id: string }[] = [];
  @Output() subpageBackClicked = new EventEmitter<void>();
  @Output() tabChange = new EventEmitter<string>();

  private readonly themeService = inject(ThemeService);

  // The back button renders off the main tab only (this header persists across pages) and always
  // navigates in-app; exiting to the parent is V3PoweredByHeader's close button (AI-648, AI-665).
  readonly backIconSrc = themeAsset(this.themeService, 'back');
}
